import React, { forwardRef } from 'react';
import { Search } from 'lucide-react';

/**
 * Universal Search Input Component - PROMPT-208-UNIVERSAL
 * 
 * This component provides a consistent search input across the entire application.
 * It ensures the search icon is always visible, properly aligned, and doesn't overlap with text.
 * 
 * Usage:
 * <SearchInput
 *   placeholder="Search..."
 *   value={searchTerm}
 *   onChange={(e) => setSearchTerm(e.target.value)}
 *   className="custom-class" // Optional additional classes
 * />
 */
const SearchInput = forwardRef(({ 
  placeholder = 'Search...', 
  value, 
  onChange, 
  onFocus,
  onBlur,
  onKeyDown,
  className = '',
  disabled = false,
  ...props 
}, ref) => {
  return (
    <div className={`ui-search ${className}`}>
      <span className="ui-search-icon">
        <Search size={16} />
      </span>
      <input
        ref={ref}
        type="text"
        className="ui-search-input"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        disabled={disabled}
        {...props}
      />
    </div>
  );
});

SearchInput.displayName = 'SearchInput';

export default SearchInput;
